import MainLayout from './main-layout';

export default MainLayout;
